'use strict';

// Call each of the handlers on event
function callHandlers(handlers) {
  var _this = this;
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  handlers.forEach(function (handler) {
    handler.apply(_this, args);
  });
}

// An interface for holding onto the functions before merging

// Takes the 'customHandlers' (what the user passes in through props)
// and the 'internalHandlers' (what the component needs internally)
// and combines them in a way that the internal handlers fire first and then
// the user custom ones.
var bindHandlers = function bindHandlers(component, customHandlers, internalHandlers) {
  var combinedHandlerArrays = {};
  var combinedHandlers = {};
  var eventsUsed = [];

  // If internal handlers were passed, add them first (so they can be fired first)
  if (internalHandlers) {
    for (var _event in internalHandlers) {
      combinedHandlerArrays[_event] = [internalHandlers[_event]];
      eventsUsed.push(_event);
    }
  }

  // Add any custom handlers passed
  for (var _event2 in customHandlers) {
    if (combinedHandlerArrays[_event2]) {
      combinedHandlerArrays[_event2].push(customHandlers[_event2]);
    } else {
      combinedHandlerArrays[_event2] = [customHandlers[_event2]];
      eventsUsed.push(_event2);
    }
  }

  // Bind all of the functions from both sets of handlers
  eventsUsed.forEach(function (event) {
    combinedHandlers[event] = callHandlers.bind(component, combinedHandlerArrays[event]);
  });
  return combinedHandlers;
};

module.exports = bindHandlers;
